import React, { useState, useEffect } from "react";
import {
  Breadcrumbs,
  Button,
  Container,
  Grid,
  Typography,
  Box,
} from "@mui/material";
import ColorPalette from "../VideoGenSettings/ColorPalette";
import ColorLensOutlinedIcon from "@mui/icons-material/ColorLensOutlined";
import { useWorkspace } from "../../../../contexts/WorkspaceContext";

const color = [
  { id: 2, name: "Coral", color_code: "#D98E8E" },
  { id: 3, name: "Purple", color_code: "#9370DB" },
  { id: 4, name: "Red", color_code: "#DC143C" },
  { id: 5, name: "", color_code: "#FFDAB9" },
  { id: 6, name: "", color_code: "#98FB98" },
];

const HeygenVideoBackground = (props) => {
  const { selectedBgColorForHeygenVideo, setSeletedBgColorForHeygenVideo } =  useWorkspace();
  const theme = localStorage.getItem("theme");
  const [selectedBackground, setSelectedBackground] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState("Solid color");
  const [selectedCategoryColorData, setSelectedCategoryColorData] =
    useState(color);
  const [selectedCategoryImageData, setSelectedCategoryImageData] =
    useState(null);
  const [selectedCategoryVideoData, setSelectedCategoryVideoData] =
    useState(null);
  const [categories, setCategories] = useState(["Solid color"]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [showcolorpalette, setShowcolorpalette] = useState(false);
  const [selectedcolor, setSelectedColor] = useState(selectedBgColorForHeygenVideo);
  const [selectedColorForCaptionText, setSelectedColorForCaptionText] =
    useState("#FFFFFF");
  const [selectedcolorid, setSelectedColorId] = useState();

  const handleCategorySelect = (categories) => {
    setSelectedCategory(categories);
  };

  const handleCloseColorPalette = () => {
    setAnchorEl(null);
    setShowcolorpalette(false);
  };

  const rgbaToHex = ({ r, g, b }) => {
    const red = r.toString(16).padStart(2, "0");
    const green = g.toString(16).padStart(2, "0");
    const blue = b.toString(16).padStart(2, "0");
    return `#${red}${green}${blue}`;
  };

  const hexToRgb = (hex) => {
  hex = hex.replace(/^#/, "");

  if (hex.length === 3) {
    hex = hex.split("").map((char) => char + char).join("");
  }
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  return { r, g, b };
};

useEffect(()=>{
   if(selectedBgColorForHeygenVideo != "#FFFFFF" || "#ffffff"){
      setSelectedColor(selectedBgColorForHeygenVideo)
    }
},[])

  // useEffect(() => {
  //   setSeletedBgColorForHeygenVideo(rgbaToHex(selectedcolor));
  //   if (props.timelineItems) {
  //     props.timelineItems((prevItems) => {
  //       const items = [...prevItems];

  //       items[props.activeTimelineItem] = {
  //         ...items[props.activeTimelineItem],
  //         background: selectedBgColorForHeygenVideo,
  //       };
  //       return items;
  //     });
  //   }
  // }, [selectedcolor]);

  if (props.color && props.color.length > 0)
    setSeletedBgColorForHeygenVideo(props.color);

  const handleBackgroundSelect = (colorObj) => {
    setSelectedColorId(colorObj?.id);
    setSeletedBgColorForHeygenVideo(colorObj?.color_code);
    // Only update timeline items if the props are provided (from VideoGenerate.jsx)
    if (props.timelineItems && typeof props.timelineItems === 'function' && props.activeTimelineItem !== undefined) {
      props.timelineItems((prevItems) => {
        const items = [...prevItems];

        items[props.activeTimelineItem] = {
          ...items[props.activeTimelineItem],
          background: colorObj?.color_code || selectedBgColorForHeygenVideo,
        };

        return items;
      });
    }
  };

  const renderBreadcrumbs = () => (
    <div style={{ paddingTop: "20px" }}>
      <Typography
        variant="h6"
        gutterBottom
        style={{
          fontSize: "16px",
          fontWeight: "500",
          width: "193px",
          height: "20px",
          marginBottom: "20px",
        }}
      >
        Select Video Background
      </Typography>
      <Grid container spacing={2}>
        {categories?.map((category, index) => (
          <Grid item key={index} xs="auto" style={{ gap: "12px" }}>
            <Button
              style={{ margin: "0px", padding: "6px 12px" }}
              variant="outlined"
              onClick={() => handleCategorySelect(category)}
              sx={{
                fontFamily: "Inter",
                fontSize: "14px",
                fontWeight: 600,
                lineHeight: "20px",
                letterSpacing: "0.1px",
                textTransform: "none",
                backgroundColor:
                  selectedCategory === category ? "#CAC4D0" : "#2F355F",
                color:
                  theme === "dark"
                    ? selectedCategory === category
                      ? "#17182C"
                      : "white"
                    : "",
                "&:hover": {
                  backgroundColor: "#373E6D",
                  border: " 1px solid #373E6D",
                },
                borderColor:
                  selectedCategory === category ? "#cac4d0" : "transparent",
                m: 0.5, // Add margin for spacing
              }}
            >
              {category}
            </Button>
          </Grid>
        ))}
      </Grid>
    </div>
  );

  const renderBackgrounds = () => {
    if (
      !selectedCategory ||
      selectedCategory == "Image" ||
      selectedCategory == "Video"
    )
      return null;
    return (
      <>
        <Grid item xs={6}>
          <Box
            onClick={(event) => {
              setShowcolorpalette(!showcolorpalette);
              setAnchorEl(event.currentTarget);
              handleBackgroundSelect({ id: 0, name: "", color_code: "" });
            }}
            sx={{
              cursor: "pointer",
              border:
                selectedBackground?.id === 0 ? "5px solid orange" : "none",
              backgroundColor: `${selectedcolor}`,
              color: "#17182C",
              height: "175px",
              borderRadius: "8px",
              width: "300px",
              display: "flex",
              alignItems: "end",
              justifyContent: "space-between",
              padding: "16px",
              "&:hover": {
                border: "2px solid rgba(202, 196, 208, 0.60)",
                padding: "16px",
              },
            }}
          >
            <Box
              sx={{
                border: "",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "300px",
              }}
            >
              <Box
                sx={{
                  fontFamily: "Inter",
                  fontSize: "14px",
                  fontStyle: "normal",
                  fontWeight: 600,
                  lineHeight: "20px",
                  letterSpacing: "0.1px",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    backgroundColor: "rgba(202, 196, 208, 0.60)",
                    border: "1px solid rgba(0, 0, 0, 0.20)",
                    padding: "8px",
                    borderRadius: "8px",
                  }}
                >
                  {/* <Box sx={{}}> */}
                  <ColorLensOutlinedIcon /> <Box>
                    {"Choose custom color"}
                  </Box>{" "}
                </Box>
                {/* </Box> */}
              </Box>
              <Box
                sx={{
                  fontFamily: "Inter",
                  fontSize: "14px",
                  fontStyle: "normal",
                  fontWeight: 600,
                  lineHeight: "20px",
                  letterSpacing: "0.1px",
                }}
              >
                {selectedcolor}
              </Box>
            </Box>
          </Box>
        </Grid>
        <Grid container mt={1} spacing={2}>
          {selectedCategoryColorData?.map((background) => (
            <Grid item xs={6} key={background.id}>
              <Box
                sx={{
                  // width: "307px",
                  cursor: "pointer",
                  border:
                    selectedcolorid === background.id
                      ? "2px solid #CAC4D0"
                      : "none",
                  backgroundColor: `${background?.color_code}`,
                  color: "#17182C",
                  height: "175px",
                  borderRadius: "8px",
                  display: "flex",
                  alignItems: "end",
                  justifyContent: "space-between",
                  padding: "16px",
                  "&:hover": {
                    border: "2px solid rgba(202, 196, 208, 0.60)",
                    padding: "16px",
                  },
                }}
                onClick={() => handleBackgroundSelect(background)}
              >
                <Box
                  sx={{
                    fontFamily: "Inter",
                    fontSize: "14px",
                    fontStyle: "normal",
                    fontWeight: 600,
                    lineHeight: "20px",
                    letterSpacing: "0.1px",
                  }}
                >
                  {background?.name == "white" ? "Custom" : background?.name}
                </Box>
                <Box
                  sx={{
                    fontFamily: "Inter",
                    fontSize: "14px",
                    fontStyle: "normal",
                    fontWeight: 600,
                    lineHeight: "20px",
                    letterSpacing: "0.1px",
                  }}
                >
                  {background?.color_code}
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </>
    );
  };

  return (
    <Box
      style={{
        color: theme === "dark" ? "white" : "black",
      }}
    >
      {renderBreadcrumbs()}
      <Box mt={2}>{renderBackgrounds()}</Box>
      <ColorPalette
        anchorEl={anchorEl}
        handleCloseColorPalette={handleCloseColorPalette}
        color={selectedcolor}
        setColor={setSelectedColor}
        selectedcolor={selectedBgColorForHeygenVideo}
      />
    </Box>
  );
};

export default HeygenVideoBackground;
